// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   GROUP CREATIVES SECTION
   Uses file-card styles from creative-upload.css
   ============================================ */

.group-creatives-section {
  margin-top: 24px;
}

/* Section Header */
.group-creatives-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.group-creatives-section .section-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

/* Loading State */
.creatives-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

/* Empty State - Clickable */
.creatives-empty-clickable {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  border: 2px dashed var(--border-color);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.creatives-empty-clickable:hover {
  border-color: var(--accent-orange);
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);
}

.creatives-empty-clickable.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.creatives-empty-clickable .empty-icon {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

.creatives-empty-clickable:hover .empty-icon {
  transform: scale(1.1);
  background: var(--accent-gradient);
}

.creatives-empty-clickable .empty-icon svg {
  width: 28px;
  height: 28px;
  color: var(--text-tertiary);
  transition: all 0.3s ease;
  position: absolute;
}

.creatives-empty-clickable .empty-icon .icon-hover {
  opacity: 0;
  transform: rotate(-90deg) scale(0.5);
}

.creatives-empty-clickable:hover .empty-icon svg {
  color: white;
}

.creatives-empty-clickable:hover .empty-icon .icon-default {
  opacity: 0;
  transform: rotate(90deg) scale(0.5);
}

.creatives-empty-clickable:hover .empty-icon .icon-hover {
  opacity: 1;
  transform: rotate(0) scale(1);
}

.creatives-empty-clickable .text-container {
  position: relative;
  height: 24px;
  margin-bottom: 4px;
}

.creatives-empty-clickable .text-default,
.creatives-empty-clickable .text-hover {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.creatives-empty-clickable .text-default {
  color: var(--text-primary);
  opacity: 1;
}

.creatives-empty-clickable .text-hover {
  color: var(--accent-orange);
  opacity: 0;
}

.creatives-empty-clickable:hover .text-default {
  opacity: 0;
}

.creatives-empty-clickable:hover .text-hover {
  opacity: 1;
}

.creatives-empty-clickable .subtext {
  font-size: 13px;
  color: var(--text-secondary);
  transition: all 0.3s ease;
}

.creatives-empty-clickable:hover .subtext {
  color: var(--text-tertiary);
}

/* ============================================
   FILE CARD STYLES (copied from creative-upload.css)
   ============================================ */

.group-creatives-section .file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
}

.group-creatives-section .file-card {
  position: relative;
  background: var(--bg-tertiary);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  animation: fadeInScale 0.3s ease backwards;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.group-creatives-section .file-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.group-creatives-section .file-card-preview {
  position: relative;
  aspect-ratio: 1;
  background: #ffffff;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-creatives-section .file-card-preview img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.group-creatives-section .file-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-creatives-section .file-card-placeholder svg {
  width: 32px;
  height: 32px;
  opacity: 0.4;
}

.group-creatives-section .file-card-placeholder.image {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
}

.group-creatives-section .file-card-placeholder.video {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #d32f2f;
}

.group-creatives-section .file-card-placeholder.html5 {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  color: #7b1fa2;
}

.group-creatives-section .file-card-type {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.group-creatives-section .file-card-type svg {
  width: 14px;
  height: 14px;
  color: var(--text-secondary);
}

.group-creatives-section .file-card-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease;
}

.group-creatives-section .file-card:hover .file-card-remove {
  opacity: 1;
}

.group-creatives-section .file-card-remove:hover {
  background: var(--danger);
}

.group-creatives-section .file-card-remove svg {
  width: 14px;
  height: 14px;
}

.group-creatives-section .file-card-info {
  padding: 10px;
}

.group-creatives-section .file-card-name {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.group-creatives-section .file-card-meta {
  font-size: 11px;
  color: var(--text-tertiary);
}

/* Add More Card */
.add-more-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 180px;
  background: transparent;
  border: 2px dashed var(--border-color);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-more-card:hover {
  border-color: var(--accent-orange);
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);
}

.add-more-card svg {
  width: 28px;
  height: 28px;
  color: var(--text-tertiary);
  transition: color 0.2s ease;
}

.add-more-card:hover svg {
  color: var(--accent-orange);
}

.add-more-card span {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-tertiary);
  transition: color 0.2s ease;
}

.add-more-card:hover span {
  color: var(--accent-orange);
}

/* ============================================
   FILE CARDS IN MODAL
   ============================================ */

.creatives-modal .file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  min-height: 200px;
}

.creatives-modal .file-card {
  position: relative;
  background: var(--bg-tertiary);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.creatives-modal .file-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-color: rgba(255, 107, 74, 0.3);
}

.creatives-modal .file-card.selected {
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.15);
}

.creatives-modal .file-card.was-assigned {
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);
}

.creatives-modal .file-card-preview {
  position: relative;
  aspect-ratio: 1;
  background: #ffffff;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.creatives-modal .file-card-preview img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.creatives-modal .file-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.creatives-modal .file-card-placeholder svg {
  width: 32px;
  height: 32px;
  opacity: 0.4;
}

.creatives-modal .file-card-placeholder.image {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
}

.creatives-modal .file-card-placeholder.video {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #d32f2f;
}

.creatives-modal .file-card-placeholder.html5 {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  color: #7b1fa2;
}

.creatives-modal .file-card-type {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.creatives-modal .file-card-type svg {
  width: 14px;
  height: 14px;
  color: var(--text-secondary);
}

.creatives-modal .file-card-info {
  padding: 8px 10px;
}

.creatives-modal .file-card-name {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.creatives-modal .file-card-meta {
  font-size: 11px;
  color: var(--text-tertiary);
}

/* Checkbox */
.file-card-checkbox {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid var(--border-color);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.creatives-modal .file-card:hover .file-card-checkbox {
  border-color: var(--accent-orange);
}

.creatives-modal .file-card.selected .file-card-checkbox {
  background: var(--accent-gradient);
  border-color: transparent;
}

.file-card-checkbox svg {
  width: 14px;
  height: 14px;
  color: white;
}

/* ============================================
   MODAL
   ============================================ */

.creatives-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.creatives-modal {
  width: 100%;
  max-width: 900px;
  max-height: 85vh;
  background: var(--bg-secondary);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Modal Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px 20px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.3px;
}

.modal-close {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: var(--danger);
  color: white;
}

.modal-close svg {
  width: 18px;
  height: 18px;
}

/* Tab Switcher */
.modal-tabs {
  display: flex;
  padding: 0 28px;
  background: var(--bg-primary);
  position: relative;
}

.modal-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.2s ease;
  position: relative;
  z-index: 1;
}

.modal-tab svg {
  width: 18px;
  height: 18px;
}

.modal-tab.active {
  color: var(--text-primary);
}

.tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: var(--bg-tertiary);
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-secondary);
}

.modal-tab.active .tab-count {
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.15) 0%, rgba(142, 58, 154, 0.15) 100%);
  color: var(--accent-orange);
}

.tab-count.upload {
  background: var(--accent-gradient);
  color: white;
}

.tab-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50%;
  height: 3px;
  background: var(--accent-gradient);
  border-radius: 3px 3px 0 0;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.tab-indicator.upload {
  transform: translateX(100%);
}

/* Modal Content */
.modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 28px;
}

/* Creatives Toolbar */
.creatives-toolbar {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.search-input-wrapper {
  flex: 1 1;
  position: relative;
}

.search-input-wrapper svg {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: var(--text-tertiary);
}

.search-input-wrapper input {
  width: 100%;
  padding: 12px 14px 12px 44px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.2s ease;
}

.search-input-wrapper input:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.search-input-wrapper input::placeholder {
  color: var(--text-tertiary);
}

/* Type Filter */
.type-filter {
  display: flex;
  background: var(--bg-tertiary);
  border-radius: 10px;
  padding: 4px;
}

.type-filter-btn {
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.type-filter-btn:hover:not(.active) {
  color: var(--text-primary);
}

.type-filter-btn.active {
  background: var(--bg-secondary);
  color: var(--text-primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Selection Info */
.selection-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  font-size: 13px;
  color: var(--text-secondary);
}

.selection-change {
  padding: 3px 8px;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(142, 58, 154, 0.1) 100%);
  color: var(--accent-orange);
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
}

/* Grid states */
.grid-loading,
.grid-empty {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: var(--text-secondary);
}

/* ============================================
   UPLOAD SECTION (in modal)
   ============================================ */

.upload-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.upload-drop-zone {
  position: relative;
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 250px;
}

.upload-drop-zone .drop-zone-border {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  padding: 2px;
  background: linear-gradient(135deg,
    rgba(255, 107, 74, 0.25) 0%,
    rgba(233, 75, 108, 0.25) 50%,
    rgba(142, 58, 154, 0.25) 100%
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  transition: all 0.3s ease;
}

.upload-drop-zone:hover .drop-zone-border,
.upload-drop-zone.dragging .drop-zone-border {
  background: var(--accent-gradient);
}

.upload-drop-zone.dragging {
  transform: scale(1.01);
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);
}

.upload-drop-zone.has-files {
  padding: 20px;
}

.upload-drop-zone .drop-zone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-drop-zone .drop-zone-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(142, 58, 154, 0.1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.upload-drop-zone:hover .drop-zone-icon,
.upload-drop-zone.dragging .drop-zone-icon {
  transform: translateY(-4px);
}

.upload-drop-zone .drop-zone-icon svg {
  width: 28px;
  height: 28px;
  color: var(--accent-orange);
}

.upload-drop-zone .drop-zone-text {
  text-align: center;
}

.upload-drop-zone .drop-zone-title {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.upload-drop-zone .drop-zone-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
}

.upload-drop-zone .drop-zone-link {
  color: var(--accent-orange);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.upload-drop-zone .drop-zone-formats {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

.upload-drop-zone .drop-zone-formats span {
  padding: 4px 10px;
  background: var(--bg-tertiary);
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Upload Files Grid (in modal) */
.upload-files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;
}

/* Add Files Card */
.add-files-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 100px;
  background: transparent;
  border: 2px dashed var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-files-card:hover {
  border-color: var(--accent-orange);
  background: rgba(255, 107, 74, 0.03);
}

.add-files-card svg {
  width: 24px;
  height: 24px;
  color: var(--text-tertiary);
}

.add-files-card:hover svg {
  color: var(--accent-orange);
}

.add-files-card span {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-tertiary);
}

.add-files-card:hover span {
  color: var(--accent-orange);
}

/* Upload Actions */
.upload-actions {
  display: flex;
  justify-content: center;
}

.btn-upload-all {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  background: var(--accent-gradient);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.3);
}

.btn-upload-all:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.4);
}

.btn-upload-all svg {
  width: 18px;
  height: 18px;
}

/* Upload Success Notice */
.upload-success-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: rgba(46, 204, 113, 0.1);
  border-radius: 10px;
  color: var(--success);
  font-size: 13px;
  font-weight: 600;
}

.upload-success-notice svg {
  width: 18px;
  height: 18px;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 28px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.btn-cancel {
  padding: 12px 24px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

.btn-apply-selection {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  background: var(--accent-gradient);
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.25);
}

.btn-apply-selection:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.35);
}

.btn-apply-selection:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-apply-selection svg {
  width: 18px;
  height: 18px;
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 768px) {
  .creatives-modal {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .modal-content {
    padding: 16px;
  }

  .creatives-toolbar {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/group-creatives.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,+FAA+F;AACjG;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+FAA+F;EAC/F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,+FAA+F;AACjG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,+FAA+F;AACjG;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+FAA+F;EAC/F,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,6FAA6F;EAC7F,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ;;;;GAIC;EACD;;6BAE2B;EAE3B,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,+FAA+F;AACjG;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ============================================\n   GROUP CREATIVES SECTION\n   Uses file-card styles from creative-upload.css\n   ============================================ */\n\n.group-creatives-section {\n  margin-top: 24px;\n}\n\n/* Section Header */\n.group-creatives-section .section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.group-creatives-section .section-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0;\n}\n\n/* Loading State */\n.creatives-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n}\n\n/* Empty State - Clickable */\n.creatives-empty-clickable {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  border: 2px dashed var(--border-color);\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.creatives-empty-clickable:hover {\n  border-color: var(--accent-orange);\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);\n}\n\n.creatives-empty-clickable.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.creatives-empty-clickable .empty-icon {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.08) 0%, rgba(142, 58, 154, 0.08) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  transition: all 0.3s ease;\n}\n\n.creatives-empty-clickable:hover .empty-icon {\n  transform: scale(1.1);\n  background: var(--accent-gradient);\n}\n\n.creatives-empty-clickable .empty-icon svg {\n  width: 28px;\n  height: 28px;\n  color: var(--text-tertiary);\n  transition: all 0.3s ease;\n  position: absolute;\n}\n\n.creatives-empty-clickable .empty-icon .icon-hover {\n  opacity: 0;\n  transform: rotate(-90deg) scale(0.5);\n}\n\n.creatives-empty-clickable:hover .empty-icon svg {\n  color: white;\n}\n\n.creatives-empty-clickable:hover .empty-icon .icon-default {\n  opacity: 0;\n  transform: rotate(90deg) scale(0.5);\n}\n\n.creatives-empty-clickable:hover .empty-icon .icon-hover {\n  opacity: 1;\n  transform: rotate(0) scale(1);\n}\n\n.creatives-empty-clickable .text-container {\n  position: relative;\n  height: 24px;\n  margin-bottom: 4px;\n}\n\n.creatives-empty-clickable .text-default,\n.creatives-empty-clickable .text-hover {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.creatives-empty-clickable .text-default {\n  color: var(--text-primary);\n  opacity: 1;\n}\n\n.creatives-empty-clickable .text-hover {\n  color: var(--accent-orange);\n  opacity: 0;\n}\n\n.creatives-empty-clickable:hover .text-default {\n  opacity: 0;\n}\n\n.creatives-empty-clickable:hover .text-hover {\n  opacity: 1;\n}\n\n.creatives-empty-clickable .subtext {\n  font-size: 13px;\n  color: var(--text-secondary);\n  transition: all 0.3s ease;\n}\n\n.creatives-empty-clickable:hover .subtext {\n  color: var(--text-tertiary);\n}\n\n/* ============================================\n   FILE CARD STYLES (copied from creative-upload.css)\n   ============================================ */\n\n.group-creatives-section .file-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 16px;\n}\n\n.group-creatives-section .file-card {\n  position: relative;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  animation: fadeInScale 0.3s ease backwards;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.group-creatives-section .file-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n.group-creatives-section .file-card-preview {\n  position: relative;\n  aspect-ratio: 1;\n  background: #ffffff;\n  overflow: hidden;\n  border-radius: 12px 12px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.group-creatives-section .file-card-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.group-creatives-section .file-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.group-creatives-section .file-card-placeholder svg {\n  width: 32px;\n  height: 32px;\n  opacity: 0.4;\n}\n\n.group-creatives-section .file-card-placeholder.image {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  color: #1976d2;\n}\n\n.group-creatives-section .file-card-placeholder.video {\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  color: #d32f2f;\n}\n\n.group-creatives-section .file-card-placeholder.html5 {\n  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);\n  color: #7b1fa2;\n}\n\n.group-creatives-section .file-card-type {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.group-creatives-section .file-card-type svg {\n  width: 14px;\n  height: 14px;\n  color: var(--text-secondary);\n}\n\n.group-creatives-section .file-card-remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  border: none;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all 0.2s ease;\n}\n\n.group-creatives-section .file-card:hover .file-card-remove {\n  opacity: 1;\n}\n\n.group-creatives-section .file-card-remove:hover {\n  background: var(--danger);\n}\n\n.group-creatives-section .file-card-remove svg {\n  width: 14px;\n  height: 14px;\n}\n\n.group-creatives-section .file-card-info {\n  padding: 10px;\n}\n\n.group-creatives-section .file-card-name {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n}\n\n.group-creatives-section .file-card-meta {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n/* Add More Card */\n.add-more-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 180px;\n  background: transparent;\n  border: 2px dashed var(--border-color);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.add-more-card:hover {\n  border-color: var(--accent-orange);\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);\n}\n\n.add-more-card svg {\n  width: 28px;\n  height: 28px;\n  color: var(--text-tertiary);\n  transition: color 0.2s ease;\n}\n\n.add-more-card:hover svg {\n  color: var(--accent-orange);\n}\n\n.add-more-card span {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-tertiary);\n  transition: color 0.2s ease;\n}\n\n.add-more-card:hover span {\n  color: var(--accent-orange);\n}\n\n/* ============================================\n   FILE CARDS IN MODAL\n   ============================================ */\n\n.creatives-modal .file-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n  min-height: 200px;\n}\n\n.creatives-modal .file-card {\n  position: relative;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n.creatives-modal .file-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  border-color: rgba(255, 107, 74, 0.3);\n}\n\n.creatives-modal .file-card.selected {\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.15);\n}\n\n.creatives-modal .file-card.was-assigned {\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);\n}\n\n.creatives-modal .file-card-preview {\n  position: relative;\n  aspect-ratio: 1;\n  background: #ffffff;\n  overflow: hidden;\n  border-radius: 10px 10px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.creatives-modal .file-card-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.creatives-modal .file-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.creatives-modal .file-card-placeholder svg {\n  width: 32px;\n  height: 32px;\n  opacity: 0.4;\n}\n\n.creatives-modal .file-card-placeholder.image {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  color: #1976d2;\n}\n\n.creatives-modal .file-card-placeholder.video {\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  color: #d32f2f;\n}\n\n.creatives-modal .file-card-placeholder.html5 {\n  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);\n  color: #7b1fa2;\n}\n\n.creatives-modal .file-card-type {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.creatives-modal .file-card-type svg {\n  width: 14px;\n  height: 14px;\n  color: var(--text-secondary);\n}\n\n.creatives-modal .file-card-info {\n  padding: 8px 10px;\n}\n\n.creatives-modal .file-card-name {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n}\n\n.creatives-modal .file-card-meta {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n/* Checkbox */\n.file-card-checkbox {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.95);\n  border: 2px solid var(--border-color);\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.creatives-modal .file-card:hover .file-card-checkbox {\n  border-color: var(--accent-orange);\n}\n\n.creatives-modal .file-card.selected .file-card-checkbox {\n  background: var(--accent-gradient);\n  border-color: transparent;\n}\n\n.file-card-checkbox svg {\n  width: 14px;\n  height: 14px;\n  color: white;\n}\n\n/* ============================================\n   MODAL\n   ============================================ */\n\n.creatives-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.creatives-modal {\n  width: 100%;\n  max-width: 900px;\n  max-height: 85vh;\n  background: var(--bg-secondary);\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Modal Header */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 28px 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.modal-header h2 {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.3px;\n}\n\n.modal-close {\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  background: var(--danger);\n  color: white;\n}\n\n.modal-close svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Tab Switcher */\n.modal-tabs {\n  display: flex;\n  padding: 0 28px;\n  background: var(--bg-primary);\n  position: relative;\n}\n\n.modal-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 16px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: color 0.2s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.modal-tab svg {\n  width: 18px;\n  height: 18px;\n}\n\n.modal-tab.active {\n  color: var(--text-primary);\n}\n\n.tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  background: var(--bg-tertiary);\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.modal-tab.active .tab-count {\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.15) 0%, rgba(142, 58, 154, 0.15) 100%);\n  color: var(--accent-orange);\n}\n\n.tab-count.upload {\n  background: var(--accent-gradient);\n  color: white;\n}\n\n.tab-indicator {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 50%;\n  height: 3px;\n  background: var(--accent-gradient);\n  border-radius: 3px 3px 0 0;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.tab-indicator.upload {\n  transform: translateX(100%);\n}\n\n/* Modal Content */\n.modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 28px;\n}\n\n/* Creatives Toolbar */\n.creatives-toolbar {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.search-input-wrapper {\n  flex: 1;\n  position: relative;\n}\n\n.search-input-wrapper svg {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  color: var(--text-tertiary);\n}\n\n.search-input-wrapper input {\n  width: 100%;\n  padding: 12px 14px 12px 44px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n}\n\n.search-input-wrapper input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.search-input-wrapper input::placeholder {\n  color: var(--text-tertiary);\n}\n\n/* Type Filter */\n.type-filter {\n  display: flex;\n  background: var(--bg-tertiary);\n  border-radius: 10px;\n  padding: 4px;\n}\n\n.type-filter-btn {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.type-filter-btn:hover:not(.active) {\n  color: var(--text-primary);\n}\n\n.type-filter-btn.active {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n/* Selection Info */\n.selection-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.selection-change {\n  padding: 3px 8px;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(142, 58, 154, 0.1) 100%);\n  color: var(--accent-orange);\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Grid states */\n.grid-loading,\n.grid-empty {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   UPLOAD SECTION (in modal)\n   ============================================ */\n\n.upload-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.upload-drop-zone {\n  position: relative;\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 40px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-height: 250px;\n}\n\n.upload-drop-zone .drop-zone-border {\n  position: absolute;\n  inset: 0;\n  border-radius: 16px;\n  padding: 2px;\n  background: linear-gradient(135deg,\n    rgba(255, 107, 74, 0.25) 0%,\n    rgba(233, 75, 108, 0.25) 50%,\n    rgba(142, 58, 154, 0.25) 100%\n  );\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  pointer-events: none;\n  transition: all 0.3s ease;\n}\n\n.upload-drop-zone:hover .drop-zone-border,\n.upload-drop-zone.dragging .drop-zone-border {\n  background: var(--accent-gradient);\n}\n\n.upload-drop-zone.dragging {\n  transform: scale(1.01);\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.03) 0%, rgba(142, 58, 154, 0.03) 100%);\n}\n\n.upload-drop-zone.has-files {\n  padding: 20px;\n}\n\n.upload-drop-zone .drop-zone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.upload-drop-zone .drop-zone-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, rgba(255, 107, 74, 0.1) 0%, rgba(142, 58, 154, 0.1) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.upload-drop-zone:hover .drop-zone-icon,\n.upload-drop-zone.dragging .drop-zone-icon {\n  transform: translateY(-4px);\n}\n\n.upload-drop-zone .drop-zone-icon svg {\n  width: 28px;\n  height: 28px;\n  color: var(--accent-orange);\n}\n\n.upload-drop-zone .drop-zone-text {\n  text-align: center;\n}\n\n.upload-drop-zone .drop-zone-title {\n  display: block;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.upload-drop-zone .drop-zone-subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.upload-drop-zone .drop-zone-link {\n  color: var(--accent-orange);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.upload-drop-zone .drop-zone-formats {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.upload-drop-zone .drop-zone-formats span {\n  padding: 4px 10px;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Upload Files Grid (in modal) */\n.upload-files-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));\n  gap: 10px;\n}\n\n/* Add Files Card */\n.add-files-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 100px;\n  background: transparent;\n  border: 2px dashed var(--border-color);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-files-card:hover {\n  border-color: var(--accent-orange);\n  background: rgba(255, 107, 74, 0.03);\n}\n\n.add-files-card svg {\n  width: 24px;\n  height: 24px;\n  color: var(--text-tertiary);\n}\n\n.add-files-card:hover svg {\n  color: var(--accent-orange);\n}\n\n.add-files-card span {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-tertiary);\n}\n\n.add-files-card:hover span {\n  color: var(--accent-orange);\n}\n\n/* Upload Actions */\n.upload-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.btn-upload-all {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  background: var(--accent-gradient);\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.3);\n}\n\n.btn-upload-all:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.4);\n}\n\n.btn-upload-all svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Upload Success Notice */\n.upload-success-notice {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  background: rgba(46, 204, 113, 0.1);\n  border-radius: 10px;\n  color: var(--success);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.upload-success-notice svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 28px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.btn-cancel {\n  padding: 12px 24px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-cancel:hover {\n  border-color: var(--text-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-apply-selection {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  background: var(--accent-gradient);\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.25);\n}\n\n.btn-apply-selection:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.35);\n}\n\n.btn-apply-selection:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-apply-selection svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n\n@media (max-width: 768px) {\n  .creatives-modal {\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .modal-content {\n    padding: 16px;\n  }\n\n  .creatives-toolbar {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
